<template>
  <div class="reportIndex">
    <van-sticky>
      <div class="sticky">
        <div
          class="search"
          :style="{ paddingTop: $route.query.navHeight + 'px' }"
        >
          <!-- <div @click="callback('9000')" v-if="$route.query.wx != 'wx'">
            <van-icon size="20px" name="arrow-left" />
          </div> -->
          <div>
            <form action="/">
              <van-search
                v-model="value"
                shape="round"
                background="none"
                placeholder="搜索基因/核苷酸/氨基酸"
                @search="onSearch"
                @clear="onClear"
              >
                <template #left-icon>
                  <i style="color:#A4A9BF" class="iconfont icon-search_s"></i>
                </template>
              </van-search>
            </form>
          </div>
        </div>
        <van-tabs
          v-model="active"
          background="none"
          color="#4B84FF"
          line-width="20"
          title-active-color="#2F354D"
          title-inactive-color="#9095A7"
          @change="hanldTab"
        >
          <van-tab
            v-for="(item, index) in tabList"
            :key="index"
            title-class="badge-parent"
            :title="item.name"
            :badge="item.badge"
          >
          </van-tab>
          <!-- <van-tab
        title-class="badge-parent first"
        title="点突变/插入/缺失"
        :badge="badge_snv"
      >
      </van-tab>
      <van-tab title-class="badge-parent" title="拷贝数" :badge="badge_cnv">
      </van-tab>
      <van-tab title-class="badge-parent" title="基因重排" :badge="badge_sv">
      </van-tab> -->
        </van-tabs>
      </div>
    </van-sticky>

    <div class="content">
      <SNV v-if="active == 0" :searchVal="value" ref="child" />
      <CNV v-if="active == 1" :searchVal="value" ref="child" />
      <SV v-if="active == 2" :searchVal="value" ref="child" />
    </div>
  </div>
</template>
<script>
import isiOS from "@/utils/iosAn";
// import getStatusBarHeight from '@/utils/barHeight'
import { mapMutations } from "vuex";
import { cnvData, snvData, svData } from "@/api/reportQuery";
// import SNV from "./components/variation/SNV.vue";
// import CNV from "./components/variation/CNV.vue";
// import SV from "./components/variation/SV.vue";
export default {
  name: "reportIndex",
  components: {
    SNV: () => import("../reportQuery/components/variation/SNV.vue"),
    CNV: () => import("../reportQuery/components/variation/CNV.vue"),
    SV: () => import("../reportQuery/components/variation/SV.vue"),
    // SNV,
    // CNV,
    // SV,
  },
  data() {
    return {
      active: 0,
      badge_snv: "",
      badge_cnv: "",
      badge_sv: "",
      value: "",
      tabList: [
        {
          name: "点突变/插入/缺失",
          badge: 0,
        },
        {
          name: "拷贝数",
          badge: 0,
        },
        {
          name: "基因重排",
          badge: 0,
        },
      ],
    };
  },

  mounted() {
    console.log(this.$route.query.navHeight, "222");
    let params = {
      labOriginalSampleNo: this.$route.query.fname,
      productId: this.$route.query.fid,
    };
    this.setPublic(params);
    this.getSnv();
    this.getCnv();
    this.getSv();
  },
  methods: {
    ...mapMutations("embry", ["setPublic"]),

    async getSnv() {
      try {
        let { data } = await snvData({
          labOriginalSampleNo: this.$route.query.fname,
          productId: this.$route.query.fid,
        });
        this.badge_snv = data.length;
        if (this.badge_snv > 100) {
          this.badge_snv = 99 + "+";
        }
        this.tabList[0].badge = this.badge_snv;
      } catch (error) {
        console.log(error);
      }
    },
    async getCnv() {
      try {
        let { data } = await cnvData({
          labOriginalSampleNo: this.$route.query.fname,
          productId: this.$route.query.fid,
        });
        this.badge_cnv = data.length;
        if (this.badge_cnv > 100) {
          this.badge_cnv = 99 + "+";
        }
        this.tabList[1].badge = this.badge_cnv;
      } catch (error) {
        console.log(error);
      }
    },
    async getSv() {
      try {
        let { data } = await svData({
          labOriginalSampleNo: this.$route.query.fname,
          productId: this.$route.query.fid,
        });
        this.badge_sv = data.length;
        if (this.badge_sv > 100) {
          this.badge_sv = 99 + "+";
        }
        this.tabList[2].badge = this.badge_sv;
      } catch (error) {
        console.log(error);
      }
    },
    callback(type) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({ type: type });
      } else {
        window.android.JSCallNative(JSON.stringify({ type: type, name: "" }));
      }
    },

    hanldTab(val) {
      console.log(val);
      this.value = "";
    },
    onSearch(val) {
      this.$refs.child.searchFn();
    },
    onClear() {
      this.$refs.child.clearSearch();
    },
  },
};
</script>
<style lang="less" scoped>

/deep/.van-sticky{
    background:url('../../assets/head-bg.png') no-repeat;
    background-size: 100% 100%;
    padding: 0 16px;
}
/deep/.van-sticky--fixed {
  .sticky {
    padding-bottom: 6px;
    background:url('../../assets/head-bg.png') no-repeat;
    background-size: 100% 100%;
  }
}
/deep/.badge-parent:first-child {
  min-width: 40% !important;
}
/deep/.badge-parent {
  min-width: 30%;
  .van-info {
    background: none;
    color: #4b84ff;
    border: 0;
    top: 6px;
    right: -8px;
  }
}
.reportIndex {
  
  // padding: 0 16px;
  background: transparent;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  .content{
    padding: 0 16px;

  }
  /deep/.van-tabs__wrap {
    height: 30px;
  }
  .search {
    display: flex;
    align-items: center;
    // padding: 0 16px;
    
    div:last-child {
      width: 100%;
    }
    /deep/.van-search__content {
      background: rgba(255, 255, 255, 0.5);
      box-shadow: 0px 6px 20px -2px rgba(52, 68, 132, 0.1);
      .van-field__left-icon .van-icon,
      .van-field__right-icon .van-icon {
        color: #a4a9bf;
      }
      ::placeholder{
        color: #A4A9BF;
      }
      .van-field__control {
        font-size: 12px;
        font-family: @family;
        font-weight: 400;
        color: #A4A9BF;
      }
    }
  }
}
</style>
